import { render, staticRenderFns } from "./shopDeclareInfoList.vue?vue&type=template&id=30c2fd76&scoped=true"
import script from "./shopDeclareInfoList.vue?vue&type=script&lang=ts"
export * from "./shopDeclareInfoList.vue?vue&type=script&lang=ts"
import style0 from "./shopDeclareInfoList.vue?vue&type=style&index=0&id=30c2fd76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2fd76",
  null
  
)

export default component.exports